import PropTypes from 'prop-types';
import DatasourceBaseOauthNew from "../Datasources/DatasourceBaseOauthNew.jsx";

const DatasourceZohoDesk = (props) => {

    const ClientId = "1000.F2JRTLSXQ78KCT5WIIIBB69JSL4OTZ"
    const Scope = "ZohoSupport.basic.READ%2cZohoSupport.contacts.READ%2cDesk.calls.ALL"
    const RedirectUrl = "https://auth.cloudcti.nl/webapi/oauth2"
    const AuthUrl = "https://accounts.zoho.com/oauth/v2/auth?scope=" + Scope + "&client_id=" + ClientId + "&response_type=code&access_type=offline&redirect_uri=" + RedirectUrl

    const OAuthPollResult = async (aResponseUrl) =>
    {
        console.log("OAuthPollResult", aResponseUrl)
        if (aResponseUrl)
        {
            if (aResponseUrl.includes("zoho.com.au")) { props.IntegrationSettings.DatasourceSettings.Domain = ".com.au" }
            else if (aResponseUrl.includes("zoho.eu")) { props.IntegrationSettings.DatasourceSettings.Domain = ".eu" }
            else if (aResponseUrl.includes("zoho.in")) { props.IntegrationSettings.DatasourceSettings.Domain = ".in" }
            else if (aResponseUrl.includes("zoho.com.cn")) { props.IntegrationSettings.DatasourceSettings.Domain = ".com.cn" }
            else if (aResponseUrl.includes("zoho.jp")) { props.IntegrationSettings.DatasourceSettings.Domain = ".jp" }
            else { props.IntegrationSettings.DatasourceSettings.Domain = ".com" }

            props.OnSetReady()
        }
    }

    return <DatasourceBaseOauthNew SecurityToken={props.SecurityToken} DatasourceData={props.DatasourceData} IntegrationSettings={props.IntegrationSettings} AuthUrl={AuthUrl} CrmServerTokenController="/api/zohodesk/tokens" OnOAuthPollResult={OAuthPollResult} OnSetReady={props.OnSetReady}/>
}

DatasourceZohoDesk.propTypes = {
    SecurityToken: PropTypes.string,
    DatasourceData: PropTypes.object,
    IntegrationSettings: PropTypes.object,
    OnSetReady: PropTypes.func
}   

export default DatasourceZohoDesk